import React from 'react';
import PropTypes from 'prop-types';

import Alert from '../../../../../../../components/global/Alert';

const propTypes = {
  tagName: PropTypes.string,
  hasPurchasedSubscription: PropTypes.bool,
  className: PropTypes.string,
};

/**
 * Explains that the photo on screen is not covered by the Digital Photo Pass.
 *
 * Shown when the gallery enforces pricing tag digital downloads and this photo
 * carries a pricing tag with digital downloads disabled. Without it a purchaser
 * who already owns the pass sees a watermarked photo and no purchasing options
 * at all, with nothing saying why.
 *
 * @param {Object} props The component props.
 * @param {String} [props.tagName] The pricing tag name, e.g. "GROUP".
 * @param {Boolean} [props.hasPurchasedSubscription] If the pass is already owned.
 * @param {String} [props.className] Additional class names.
 *
 * @returns {React.ReactElement} The notice.
 */
const TeamPhotoExclusionNotice = ({
  tagName,
  hasPurchasedSubscription = false,
  className,
}) => {
  const label = tagName || 'Team';

  return (
    <Alert type="note" className={className} borderless>
      <p className="text-bold mb-1">
        {label} photos are not included in the Digital Photo Pass
      </p>
      <p className="mb-0">
        {hasPurchasedSubscription
          ? `Your Digital Photo Pass covers your other matched photos. This ${label} photo is not available for purchase.`
          : `The Digital Photo Pass covers your other matched photos, but not this ${label} photo.`}
      </p>
    </Alert>
  );
};

TeamPhotoExclusionNotice.propTypes = propTypes;

export default TeamPhotoExclusionNotice;
